export default "__VITE_ASSET__5ea4d158__"